import { useLayoutEffect, useState } from 'react';

const CHIP_WIDTH = 120;
const RESERVED_SPACE = 48;

export const useChipFit = (containerRef, itemCount) => {
	const [limitTags, setLimitTags] = useState(1);

	useLayoutEffect(() => {
		if (!containerRef.current) return;

		const container = containerRef.current;
		const { paddingLeft, paddingRight } = window.getComputedStyle(container);
		const horizontalPadding = parseFloat(paddingLeft) + parseFloat(paddingRight);

		const available = container.offsetWidth - horizontalPadding - RESERVED_SPACE;
		const maxVisible = Math.floor(available / CHIP_WIDTH);

		// If every item fits, no overflow chip is rendered at all. Otherwise the
		// overflow chip itself takes up a chip's worth of space, so reserve room
		// for it rather than letting it push the row past the available width.
		const needsOverflowChip = itemCount > maxVisible;
		const limit = needsOverflowChip
			? Math.floor((available - CHIP_WIDTH) / CHIP_WIDTH)
			: maxVisible;

		setLimitTags(Math.max(limit, 1));
	}, [itemCount]);

	return limitTags;
};
